"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnsupportedBtnWrapper = exports.UnsupportedSubtitle = exports.UnsupportedTitle = exports.UnsupportedWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.UnsupportedWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  margin: 50px auto 0;
`;
exports.UnsupportedTitle = styled_components_1.default.div `
  font-weight: 600;
  font-size: 18px;
  line-height: 21.48px;
  color: #1C212D;
  margin-top: 18.5px;
`;
exports.UnsupportedSubtitle = styled_components_1.default.div `
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #657089;
  margin: 16px auto 24px;
`;
exports.UnsupportedBtnWrapper = styled_components_1.default.div `
  button {
    height: 40px !important;
    div {
      height: 40px !important;
      font-size: 16px !important;
      line-height: 14px !important;
    }
  }
`;
//# sourceMappingURL=styled.js.map